import { render, staticRenderFns } from "./add.vue?vue&type=template&id=6c88978b&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c88978b')) {
      api.createRecord('6c88978b', component.options)
    } else {
      api.reload('6c88978b', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=6c88978b&", function () {
      api.rerender('6c88978b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/bigCustomer/plan/add.vue"
export default component.exports